<template>
    <div>
        <label><input type="checkbox" v-model="block.showInNavigation" ref="showInNavigation"> In Navigation anzeigen</label>
        <text-input :value="block.name" label="Name" ref="name"></text-input>
        <long-text-input :value="block.text" label="Text" ref="text"></long-text-input>
        <researchers v-model="block.researchers"/>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
import Researchers from "../Researchers";

export default {
  props: ["project", "blockData"],
  components: { Researchers },
  data() {
    return {
      block: this.blockData
    };
  },
  methods: {
    save() {
      let form = new FormData();
      for (let i = 0; i < this.block.researchers.length; i++) {
        form.append(
          "edit_contact_block[researchers][" + i + "]",
          this.block.researchers[i].id
        );
      }
      if (this.block.showInNavigation)
        form.append(
          "edit_contact_block[showInNavigation]",
          this.block.showInNavigation
        );
      form.append("edit_contact_block[submit]", 1);

      Promise.all([
        this.$refs.name.save(),
        this.$refs.text.save(),
        axios.post(
          "/api/" + store.state.language + "/block/" + this.block.id + "/edit",
          form
        )
      ]).then(responses => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blocks/ContactBlock.vue